<template>
    <div class="HomeBottom">
        <div class="tabs">
            <div class="tab tab1" :class="curMenu=='/'?'selected':''" @click="swtichTab('/')">
                <img src="@/assets/images/mpc/tab/pledge-select.png" v-if="curMenu=='/'" />
                <img src="@/assets/images/mpc/tab/pledge.png" v-else/>
                <span>{{ $t("home.pledge") }}</span>
            </div>
            <div class="tab tab5" :class="curMenu=='/mpcNode'?'selected':''" @click="swtichTab('/mpcNode')">
                <img src="@/assets/images/mpc/tab/node-select.png" v-if="curMenu=='/mpcNode'" />
                <img src="@/assets/images/mpc/tab/node.png" v-else/>
                <span>{{ $t("home.node") }}</span>
            </div>
            <div class="tab tab5" :class="curMenu=='/mpcExchange'?'selected':''" @click="swtichTab('/mpcExchange')">
                <img src="@/assets/images/mpc/tab/exchange-select.png" v-if="curMenu=='/mpcExchange'" />
                <img src="@/assets/images/mpc/tab/exchange.png" v-else/>
                <span>{{ $t("home.exchange") }}</span>
            </div>
            <!-- <div class="tab tab5" :class="curMenu=='/robot'?'selected':''" @click="swtichTab('/robot')">
                <img src="@/assets/images/mpc/tab/robot-selected.png" v-if="curMenu=='/robot'" />
                <img src="@/assets/images/mpc/tab/robot.png" v-else/>
                <span>{{ $t("home.robot")}}</span>
            </div> -->
            <div class="tab tab5" :class="curMenu=='/mpcMy'?'selected':''" @click="swtichTab('/mpcMy')">
                <img src="@/assets/images/mpc/tab/my-select.png" v-if="curMenu=='/mpcMy'" />
                <img src="@/assets/images/mpc/tab/my.png" v-else/>
                <span>{{ $t("home.my")}}</span>
            </div>
        </div>
    </div>
</template>

<script>
import bus from '@/assets/js/bus';
export default {
    name:"HomeBottom",
    props:{
    },
    data() {
        return {
            curMenu:""
        };
    },
    created() {
        this.curMenu = this.$route.path;
    },
    methods:{
        swtichTab(command){
            if(this.$route.path == command){
                return;   
            }
            this.curMenu = command;
            this.goPage(command);
        },
        
    }
}
</script>

<style lang="less" scoped>
.HomeBottom {
    .tabs{
        display:flex;
        justify-content: space-around;
        align-items: center;
        .selected{
            color: #00CCFF !important;
        }
        .tab{
            display:flex;
            flex-direction:column;
            justify-content: center;
            align-items: center;
            cursor:pointer;
            font-size:11px;
            color: #9E99D0;
            img{
                height:20px;
                width:20px;
            }
            span{ margin-top:1px; }
        }
    }
    
}
</style>
